"use client";

import { useSession } from "@/lib/auth-client";
import { REFERRAL_DISPLAY_CAP_AMOUNT } from "@/lib/opportunity-utils";
import { api } from "@/lib/trpc/react";

export function useReferralCap(): number | null {
  const { data: session, isPending, error } = useSession();
  const { data, isError } = api.referral.getMyCommissionCap.useQuery(
    undefined,
    {
      enabled: !isPending && !error && Boolean(session?.user),
    },
  );

  if (isPending || error) {
    return null;
  }
  if (!session?.user) {
    return REFERRAL_DISPLAY_CAP_AMOUNT;
  }
  return isError ? null : (data?.capAmount ?? null);
}
